var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogoMark = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3cu3mhu1a",
    x1: ".39%",
    x2: "99.61%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7865D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C05353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "6h054lmxrb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -27) translate(23 27.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35.137,
    fill: "url(#g3cu3mhu1a)",
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#6h054lmxrb)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5,
    transform: "translate(5 6.024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.067v3.112c.061.788.713 1.398 1.5 1.405h12c.857-.03 1.528-.752 1.5-1.613V2.119c.015-.414-.135-.817-.416-1.12-.282-.304-.671-.482-1.084-.497h-12c-.443.03-.855.241-1.138.584-.284.343-.415.788-.362 1.231V5.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.047L18.75 11.047 18.75 14.059M15.75 14.059L15.75 11.047"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.75,
    cy: 11.047,
    rx: 3,
    ry: 3.012
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-mark.197ec0be.svg";
export { ForwardRef as ReactComponent };